import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import AppHeader from '../../../components/AppHeader.tsx';
import { AbsenceModal, AbsenceList } from '../../../features/absences';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faDownload } from '@fortawesome/free-solid-svg-icons';
import { bookingsApi } from '@api/api';
import { BookingDto } from '@api/generated';

const BlockedTimesPage: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { entityId } = useParams<{ entityId: string }>();
  const [bookings, setBookings] = useState<BookingDto[]>([]);

  useEffect(() => {
    if (!entityId) return;
    bookingsApi
      .getBookings({
        salonId: entityId,
        dateFrom: dayjs().format('YYYY-MM-DD'),
        dateTo: dayjs().add(60, 'day').format('YYYY-MM-DD'),
      })
      .then(res => setBookings(res.data))
      .catch(err => console.error('Nelze načíst rezervace pro detekci konfliktů:', err));
  }, [entityId]);

  const existingBookings = useMemo(
    () =>
      bookings.map(b => ({
        id: b.id,
        start: b.start,
        end: b.end,
        customer: {
          firstName: b.customer.firstName,
          lastName: b.customer.lastName,
          email: b.customer.email,
          phone: b.customer.phone,
        },
        worker: { displayName: b.worker.displayName },
        serviceName: b.bookingLines?.[0]?.serviceName ?? '',
      })),
    [bookings]
  );

  const breadcrumb = [{ label: 'Rezervace' }, { label: 'Absence' }];

  return (
    <div className="h-full flex flex-col">
      <AppHeader title="Absence" breadcrumb={breadcrumb} />

      <div className="flex-1 overflow-y-auto bg-gray-50">
        <div className="p-6 space-y-6">
          <section className="bg-white rounded-lg shadow-sm p-6">
            <div className="flex items-center justify-between">
              <div>
                <h1 className="text-2xl font-semibold text-gray-900">Absence</h1>
                <p className="text-gray-600 mt-1">Spravujte absence zaměstnanců</p>
              </div>
              <div className="flex items-center space-x-3">
                <button
                  onClick={() => setIsModalOpen(true)}
                  className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors"
                >
                  <FontAwesomeIcon icon={faPlus} className="mr-2" />
                  Nová absence
                </button>
                <button className="border border-gray-300 px-4 py-2 rounded-lg hover:bg-gray-50 transition-colors">
                  <FontAwesomeIcon icon={faDownload} className="mr-2" />
                  Export
                </button>
              </div>
            </div>
          </section>

          <AbsenceList salonId={entityId} />
        </div>
      </div>

      <AbsenceModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSuccess={() => {
          // List se obnoví díky useAbsenceStore.
        }}
        salonId={entityId}
        existingBookings={existingBookings}
      />
    </div>
  );
};

export default BlockedTimesPage;
